export default __webpack_public_path__ + "static/media/Interiores6.9891414c.jpeg";